module.exports = __webpack_public_path__ + "static/img/content.7c001f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/content.png
// module id = yEWn
// module chunks = 1